// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-icon-s-flag[data-v-98f983c6] {\n  float: right;\n  line-height: 34px;\n}", ""]);
// Exports
module.exports = exports;
